module.exports = __webpack_public_path__ + "img/apple.754d82bd.png";